import React from 'react';
import { motion } from 'framer-motion';
import { GlowButton } from './GlowButton';
export function FooterCTA() {
  return <footer className="relative w-full overflow-hidden" data-id="element-74">
      {/* CTA Section */}
      <section id="obtener-pack" className="relative py-32 sm:py-40" data-id="element-75">
        {/* Background radial glow */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-76">
          <div className="w-[700px] h-[700px] bg-gradient-radial from-purple-electric/[0.06] via-gold/[0.02] to-transparent rounded-full blur-[80px]" data-id="element-77" />
        </div>

        <div className="relative max-w-4xl mx-auto px-6 text-center" data-id="element-78">
          {/* Decorative line */}
          <motion.div initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 1.2,
          ease: [0.22, 1, 0.36, 1]
        }} className="w-24 h-px bg-gradient-to-r from-transparent via-gold/50 to-transparent mx-auto mb-16" data-id="element-79" />

          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 1,
          ease: [0.22, 1, 0.36, 1]
        }} className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-12" data-id="element-80">
            Nadie muere realmente, porque nada estuvo jamás separado{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold via-gold-light to-gold" data-id="element-81">
              de lo infinito.
            </span>
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.3,
          ease: [0.22, 1, 0.36, 1]
        }} className="flex flex-col items-center justify-center gap-4" data-id="element-82">
            <GlowButton href="https://pay.hotmart.com/J104538438A" variant="gold" data-id="element-83">
              Obtener Pack
            </GlowButton>
            <p className="font-sans text-white/30 text-sm" data-id="element-84">
              Ebook + Audiobook incluidos
            </p>
          </motion.div>
        </div>
      </section>

      {/* Minimal footer */}
      <div className="relative border-t border-white/[0.04]" data-id="element-85">
        <div className="max-w-6xl mx-auto px-6 py-8 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-86">
          <div className="flex items-center gap-2" data-id="element-87">
            <span className="font-serif text-lg font-bold text-gold/60" data-id="element-88">
              DMT
            </span>
            <span className="text-white/15 text-xs font-sans" data-id="element-89">
              La Molécula de Dios
            </span>
          </div>

          <div className="flex items-center gap-6" data-id="element-90">
            <a href="#libro" className="font-sans text-xs text-white/25 hover:text-gold/60 transition-colors duration-300" data-id="element-91">
              El Libro
            </a>
            <a href="#autores" className="font-sans text-xs text-white/25 hover:text-gold/60 transition-colors duration-300" data-id="element-92">
              Autores
            </a>
          </div>

          <p className="font-sans text-xs text-white/15" data-id="element-93">
            © 2026 Pereira & Beltrán
          </p>
        </div>
      </div>
    </footer>;
}